import axios from 'axios'
import eventBus from '@/plugins/eventBus'
import { UserModel } from '@/store/models/UserModel'

export default (axiosOptions: any = {}, withoutAuthorization: any = false) => {
  const defaultOptions = {
    baseURL: process.env.VUE_APP_BASE_URL + `/api`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: '',
    },
  }

  let isUserLogged: UserModel = UserModel.getInstance()
  let accessToken = ''

  if (isUserLogged) {
    accessToken = isUserLogged.isLogged()
  }

  let options = { ...defaultOptions, ...axiosOptions }
  if (!withoutAuthorization) {
    options.headers.Authorization = 'Bearer ' + accessToken
  }

  return axios.create(options)
}
